import { updateObject } from '../utility';
import {
	OPEN_MODAL,
	CLOSE_MODAL,
	UPDATE_SHIPPING_ADDRESS,
} from '../types/modal';

const initalState = {
	name: null,
	data: {},
	shippingAddress: {},
};

const openModal = (state, action) => {
	return updateObject(state, {
		name: action.name,
		data: action.data,
	});
};

const closeModal = (state) => {
	return updateObject(state, {
		name: null,
		data: {},
	});
}

const updateShippingAddress = (state, action) => {
	return updateObject(state, {
		shippingAddress: action.address,
	});
};

const reducer = (state = initalState, action) => {
	switch (action.type) {
		case OPEN_MODAL:
			return openModal(state, action);
		case CLOSE_MODAL:
			return closeModal(state);
		case UPDATE_SHIPPING_ADDRESS:
			return updateShippingAddress(state, action);
		default:
			return state;
	}
};

export default reducer;
